import cx from 'classnames'

import { CustomCultureStatusIcon } from '~/api/backend/customCultureStatusAPI'
import { assertNever } from '~/utils/assertNever'

import BareCheckmarkIcon from './BareCheckmarkIcon'
import BareQuestionIcon from './BareQuestionIcon'
import BareWarningIcon from './BareWarningIcon'
import CloseIcon from './CloseIcon'
import cs from './culture_status_icon.scss'
import RightArrowIcon from './RightArrowIcon'
import { IconProps } from './types/IconProps'

const EmptyIcon = ({ className }: IconProps) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  />
)

export default function CultureStatusIcon({
  kind,
  className,
  size = 'sm',
}: {
  kind: CustomCultureStatusIcon
  className?: string
  size?: 'sm' | 'md' | 'lg'
}) {
  return (
    <div
      className={cx(
        cs.container,
        kindClassNames[kind],
        sizeClassNames[size],
        className,
      )}
    >
      <Glyph icon={kind} />
    </div>
  )
}

const kindClassNames: { [key in CustomCultureStatusIcon]: string } = {
  ACTIVE: cs.active,
  READY: cs.ready,
  QUESTION: cs.question,
  ALERT: cs.alert,
  PASSAGED: cs.passaged,
  TERMINATED: cs.terminated,
}

const sizeClassNames: { [key in 'sm' | 'md' | 'lg']: string } = {
  sm: cs.sizeSm,
  md: cs.sizeMd,
  lg: cs.sizeLg,
}

function Glyph({ icon }: { icon: CustomCultureStatusIcon }) {
  switch (icon) {
    case 'ACTIVE':
      return <BareCheckmarkIcon className={cs.icon} />
    case 'READY':
      // Needed to help with alignment issues
      return <EmptyIcon className={cs.icon} />
    case 'QUESTION':
      return <BareQuestionIcon className={cs.icon} />
    case 'ALERT':
      return <BareWarningIcon className={cs.icon} />
    case 'PASSAGED':
      return <RightArrowIcon className={cs.icon} />
    case 'TERMINATED':
      return <CloseIcon className={cs.icon} />
    default:
      assertNever(icon)
  }
}
